import accordions from './Accordions.vue';

export default  {
    accordions
};
